<div [formGroup]="form">
  <div class="docnum">
    <!--<select class=" select" [(ngModel)]="utilityobj.roleID">
    <option value="-1" selected disabled>Select certificate search type</option>
    <option value="0">Certificate</option>
    <option value="1">Condo Master Plan #</option>
    <option value="2">Condo Master Plan + Unit No.</option>
    <option value="3">Condo Name</option>
  </select>-->
    <label for="cert">Certificate Number <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <input type="text" id="cert" name="certnum" formControlName="certnum" maxlength="20" aria-describedby="certnum_error">
    <div id="certnum_error" class="help-block" role="alert">
      <span *ngIf="form.get('certnum').errors?.required && form.get('certnum').touched">Enter Certificate Number</span>
      <span *ngIf="form.get('certnum').errors?.pattern && form.get('certnum').touched">Use numbers in Certificate Number</span>
    </div>
  </div>
</div>

